import {actionTypes} from './actionTypes';

export const set4DNumberToUpdate = (number) => ({
    type: actionTypes.SET_4D_NUMBER_TO_UPDATE,
    payload: number
})